























import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  name: 'home001',
  components: {
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue'),
  }
})
export default class Home001 extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public title: string

  @Prop({ default: null })
  public subtitle: string

  @Prop({ default: null })
  public image: string

  @Prop({ default: null })
  public buttonCTA: string  

  @Prop({ default: false })
  public optimizeForFacebook: boolean

  @Prop({ default: null })
  public video: string


  // public reactive member variables available to the html template
  public get imageSource(): string { return `/images/${this.image}` }

  // public functions available to the html template
  public clickedSignUp() {
    this.$emit('clickedCTA')
  }

  public clickedVideo() {
    (window as any).analytics.track('Video Clicked', { video: this.video });
    (this.$refs.VideoComponent as any).show(null, 'lg', { video: this.video });     // TODO: show storyTeller video once we have one
  }

  public clickedReading() {
    (window as any).analytics.track('Reading Clicked');
    (this.$refs.ReadingComponent as any).show(null, 'lg', { type: null })
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template

  // this is necessary because path changes don't reload the component nor its subcomponents

}

